module.exports = __webpack_public_path__ + "img/icn_user.09d611ba.svg";